import { useCallback, useContext } from 'react';
import { Popover, PopoverBackdrop, PopoverButton, PopoverPanel } from '@headlessui/react';
import { BuildingStorefrontIcon } from '@heroicons/react/24/outline';
import { useTranslations } from 'use-intl';
import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import StoreFinder from 'components/commercetools-ui/organisms/header/utility-section/components/store-finder';
import { ChannelContext } from 'context/channel';
import Modal from '../../modal';

const StoreButton = () => {
  const { selectedChannel, isChannelFinderOpen, setIsChannelFinderOpen } = useContext(ChannelContext);

  const closeModal = useCallback(() => setIsChannelFinderOpen(false), []);

  const translate = useTranslations();

  const title = selectedChannel ? translate('account.account') : translate('account.sign-in');

  const handleStoreSelectorClicked = () => {
    setIsChannelFinderOpen(true);
  };

  return (
    <div className="h-40 w-fit">
      <Link link={selectedChannel ? '#' : '#'} title={title} className="hidden md:flex lg:hidden">
        <BuildingStorefrontIcon className="hidden h-fit w-28 text-white md:flex lg:hidden" />
      </Link>
      <Popover as="div" className="relative hidden h-fit lg:block">
        {() => (
          <>
            <PopoverButton title={title}>
              <div className="flex w-fit whitespace-nowrap">
                <div className="border-primary pb-8 hover:border-b-2">
                  <BuildingStorefrontIcon className="w-28 text-black" />
                </div>
              </div>
            </PopoverButton>
            <PopoverBackdrop className="fixed inset-0 z-[310] bg-gray-600 opacity-30" />
            <PopoverPanel className="absolute -left-120 top-50 z-[351] animate-[appearDropdown_0.15s_ease-in-out] rounded-sm bg-white shadow-400">
              <div className="absolute -top-20 left-1/2 z-10 w-50 -translate-x-1/2 overflow-hidden">
                <div className="size-21 origin-bottom-left rotate-45 bg-white" />
              </div>
              <div className="w-250 p-14 pb-24">
                <div className="mt-10 block w-full text-center">
                  {selectedChannel ? (
                    <p className="max-w-400 truncate whitespace-nowrap font-bold text-primary">
                      {translate('channel.myChannel', { name: selectedChannel?.name || '' })}
                    </p>
                  ) : (
                    <p className="max-w-400 truncate whitespace-nowrap font-bold text-primary">
                      {translate('channel.selectChannel')}
                    </p>
                  )}
                </div>

                <Button
                  variant="primary"
                  onClick={handleStoreSelectorClicked}
                  className="mt-32 w-full py-12 text-center text-16 leading-[16px]"
                >
                  {selectedChannel ? translate('channel.changeChannel') : translate('channel.selectChannel')}
                </Button>
              </div>
            </PopoverPanel>
          </>
        )}
      </Popover>
      <Modal
        isOpen={isChannelFinderOpen}
        onRequestClose={closeModal}
        style={{ content: { background: 'transparent', border: 'none' } }}
        className="w-[1400px] max-w-[1400px]"
        maxWidth="1400px"
        closeTimeoutMS={200}
      >
        <div className="mx-auto w-[90%] rounded-sm bg-white p-32 pt-24">
          <StoreFinder />
        </div>
      </Modal>
    </div>
  );
};

export default StoreButton;
